import React, { useState , useEffect} from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import useTraeDatos from '../hooks/useTraeDatos';
import { traeIdNombre, existeRegistro, recibeImagen, errores } from '../hooks/Funciones'
import fotoVacia from '../../paginas/img/fotoVacia.jpg'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons' // <-- import styles to be used
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import ReactPDF from '@react-pdf/renderer';

const SubirEditAprobado = ({ baseUrl, data, setData, setFuncion, registroSelect, TituloBtn, funcion, urlCertificados }) => {

	const [registro, setRegistro] = useState(funcion === 'editar' ? {...registroSelect, archivo: registroSelect.archivo !== '' ? JSON.parse(registroSelect.archivo) : ''} : { activo: true, imagePrev: fotoVacia })
	const [error, setError] = useState({ activo: false })
	const [imagenOld, setImagenOld] = useState(registro.imagen)
	const [modal, setModal] = useState(false)
	const [imagenSel, setImagenSel] = useState('')
	const [impresion, setImpresion] = useState(false)
  

	console.log('registroSelect',registroSelect)

	const EnviarCertificadoPost = async () => {

		console.log('subirá certificado')

		let {id_curso, id_usuario, nombre, nombreCurso} = registroSelect
		let fecha = moment().format('DD-MM-YYYY')

		let f = new FormData()
		f.append('id_curso', id_curso)
		f.append('id_usuario', id_usuario)
		f.append('archivo', `/pdfs/${id_usuario}${id_curso}.pdf`)
		f.append('nombre_archivo', `${id_usuario}${id_curso}.pdf`)
		f.append('nombre', nombre)
		f.append('nombreCurso', nombreCurso)
		f.append('fecha', fecha)
		f.append('METHOD', 'POST')

		await axios.post(urlCertificados, f)

			.then(response => {
				console.log(response.data)
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})

	}

	const peticionPut = async () => {

		let {id, estado, archivo} = registro

		let f = new FormData()
		f.append('id', id)
		f.append('estado', estado)
		f.append('puntaje', estado === 'aprobado' ? '100' : '0')
		f.append('METHOD', 'PUT')

		await axios.post(baseUrl, f)

			.then(response => {

				console.log(response.data)
				let dataNueva = data
				let nuevoArray = []
				dataNueva.map(item => {
					if (item.id === id) {
						nuevoArray.push({...item, estado: estado, archivo: JSON.stringify(archivo), puntaje: estado === 'aprobado' ? '100' : '0'})
					}else{nuevoArray.push(item)}
				})

				// if (estado === 'aprobado'){
				// 	EnviarCertificadoPost()
				// }

				setData(nuevoArray)
				console.log('enviado')
				errores('Limpio', setError)
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})
		setFuncion('ver')
	}

	const MostrarFoto = (foto) => {
		setImagenSel(foto)
		setModal(true)
	}

	
	const pdfRef = React.createRef();
  	const [pdfReady, setPdfReady] = useState(false);

  useEffect(() => {
    setPdfReady(true);
  }, []);

  const generatePDF = async () => {
    if (!pdfReady) return;

    const pdf = await pdfRef.current.toBlob();
	console.log('pdf',pdf)
    // Aquí puedes hacer lo que quieras con el archivo Blob
    // como, por ejemplo, descargarlo o enviarlo a un servidor
  };



	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ? <span className="error"> Error: {error.mensaje}</span> : null}
					<div><hr />

						<div className='row'>
							<div className='col-md-9'>
								<h3>{registro.nombre}</h3>
								<h5>{registro.nombreCurso}</h5>
								<h6>Tipo de Actividad: <b>{registro.tipo}</b></h6>

								{registro.tipo === 'quiz' ?
									<div className={`estadosFULL Blanco`} style={{width: 200}}>
										Porcentaje Aprobado:
										<h3> {registro.puntaje}%</h3>
									</div>
								:null}

								
							</div>
							<div className='col-md-3'>
								<div className={`estadosFULL ${registro.estado}`}>{registro.estado}</div>
								<select className="browser-default custom-select selectEstado"
										name="estado"
										value={registro.estado}
										onChange={e => setRegistro({...registro, estado: e.target.value})}>
										<option value="aprobado">Aprobado</option>
										<option value="pendiente">Pendiente</option>
										<option value="reprobado">Reprobado</option>
									</select>
								</div>
							<div className='col-md-12'>

								

								{registro.tipo === 'trabajo' ?
									<div className='row'>
										{registro.archivo.map((item, index) => {
											return(
												<div className='col-md-4' key={index}>
													<button className="FotoPrev" onClick={() => MostrarFoto(item)}>
														<img src={`${baseUrl}${item}`} />
													</button>
												</div>
											)
										})}
									</div>
								
								:null}

								{modal?
									<div style={{position: 'fixed', zIndex: 5, top: 0, left: 0, bottom: 0, backgroundSize: 'cover', right: 0, background: 'rgba(0, 0, 0, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 30}}> 
										<button
											onClick={e => setModal(false)}
											style={{position: 'absolute', top: 30, right: 50}}
											className="btn boton_estandar btn-lg">
											<FontAwesomeIcon icon={faXmark} />
                                        </button>
										<img style={{ maxWidth: '80%', maxHeight: '80%' }} src={`${baseUrl}${imagenSel}`} />
									</div>
								
								:null}


								



							</div>
						</div>

						<br />
						<div className="col text-center">
							<button onClick={peticionPut} className="btn boton_estandar">Actualizar Actividad</button>
						</div>
					</div>
					

					<br></br><br></br>
				</div>
			</div>
		</div>
	)
}

export default SubirEditAprobado